<ng-container *ngIf="item.isShown">
     <a class="nav-link" [ngClass]="item.classes" *ngIf="item.isDiable"
        >
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>

    <!-- item.url -->
    <a class="nav-link" [ngClass]="item.classes" *ngIf="item.url && !item.externalUrl && !item.function && !item.isDiable"
        [routerLink]="[item.url]" [routerLinkActive]="['active', 'mat-accent-bg']"
        [routerLinkActiveOptions]="{exact: item.exactMatch || false}" [target]="item.openInNewTab ? '_blank' : '_self'"
        matRipple>
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>

    <!-- item.externalUrl -->
    <a class="nav-link" [ngClass]="item.classes" *ngIf="item.url && item.externalUrl && !item.function && !item.isDiable"
        [href]="item.url" [target]="item.openInNewTab ? '_blank' : '_self'" matRipple>
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>

    <!-- item.function -->
    <span class="nav-link" [ngClass]="item.classes" *ngIf="!item.url && item.function && !item.isDiable" (click)="item.function()"
        matRipple>
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </span>

    <!-- item.url && item.function -->
    <a class="nav-link" [ngClass]="item.classes" *ngIf="item.url && !item.externalUrl && item.function && !item.isDiable"
        (click)="item.function()" [routerLink]="[item.url]" [routerLinkActive]="['active', 'mat-accent-bg']"
        [routerLinkActiveOptions]="{exact: item.exactMatch || false}" [target]="item.openInNewTab ? '_blank' : '_self'"
        matRipple>
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>

    <!-- item.externalUrl && item.function -->
    <a class="nav-link" [ngClass]="item.classes" *ngIf="item.url && item.externalUrl && item.function && !item.isDiable"
        (click)="item.function()" [href]="item.url" [target]="item.openInNewTab ? '_blank' : '_self'" matRipple>
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>

    <ng-template #itemContent>
        <mat-icon class="nav-link-icon" *ngIf="item.icon && item.iconType=='material' && item.iconTooltip"
            matTooltip="{{item.translate | translate}}">{{item.icon}}</mat-icon>
        <mat-icon class="nav-link-icon" *ngIf="item.icon && item.iconType=='material' && !item.iconTooltip">
            {{item.icon}}</mat-icon>
        <span class="nav-link-icon {{item.icon}}" *ngIf="item.icon && item.iconType !='material' && item.iconTooltip"
            matTooltip="{{item.translate | translate}}"></span>
        <span class="nav-link-icon {{item.icon}}"
            *ngIf="item.icon && item.iconType !='material' && !item.iconTooltip"></span>
        <span class="nav-link-title">{{item.translate | translate}}</span>
        <span class="nav-link-badge" *ngIf="item.badge"
            [ngStyle]="{'background-color': item.badge.bg,'color': item.badge.fg}">
            {{item.badge.translate | translate}}
        </span>
    </ng-template>

</ng-container>